import { Box, Flex, HStack, Text, VStack } from "@chakra-ui/react";
import React from "react";
import { calculateAge } from "../../../../utils/dob";

const PatientInfo = ({ patientData }) => {
  const bioData = patientData?.bioData;

  const patientDataArr = [
    { key: "Surname", value: bioData?.surname },
    // { key: "image", value: bioData?.image  },
    { key: "Other Names", value: bioData?.otherNames },
    { key: "Email", value: bioData?.email },
    { key: "Unit No", value: bioData?.unitNo },
    { key: "Matric No", value: bioData?.matricNo },
    { key: "Title", value: bioData?.title },
    { key: "Home Address", value: bioData?.homeAddress },
    { key: "NHIS No", value: bioData?.NHISNo },
    { key: "Patient Type", value: bioData?.patientType },
    { key: "Telephone", value: bioData?.telephone },
    { key: "Marital Status", value: bioData?.maritalStatus },
    { key: "Sex", value: bioData?.sex },
    { key: "Home Town", value: bioData?.homeTown },
    { key: "Tribe", value: bioData?.tribe },
    { key: "Occupation", value: bioData?.occupation },
    { key: "Department", value: bioData?.department },
    { key: "Religion Or Denimination", value: bioData?.religionOrDenimination },
    { key: "Date Of Birth", value: bioData?.dateOfBirth },
    { key: "Nationality", value: bioData?.nationality },
    { key: "State", value: bioData?.state },
    { key: "Date Registered", value: bioData?.dateRegistered },
    { key: "xRay Number", value: bioData?.xRayNumber },
    { key: "Sensivity", value: bioData?.sensivity },
    { key: "Rhesus", value: bioData?.rhesus },
    { key: "Genotype", value: bioData?.genotype },
    { key: "Blood Group", value: bioData?.bloodGroup },
    { key: "Allergies", value: bioData?.allergies },
  ];

  return (
    <Box w="full">
      <HStack mt="30px" spacing={"10px"}>
        <Box h="35px" w="3px" bg="#354147" />
        <Text
          lineHeight={"24.2px"}
          fontSize={"20px"}
          fontWeight={600}
          color={"#354147"}
        >
          BASIC INFORMATION
        </Text>
      </HStack>

      <Flex maxW={"936px"} flexWrap={"wrap"} p="20px" gap="25px">
        {patientDataArr.map((data) => (
          <VStack
            key={data.key}
            w="272px"
            color={"#354147"}
            align={"flex-start"}
            spacing={"3px"}
          >
            <Text
              fontSize={"16px"}
              fontWeight={500}
              lineHeight={"19.36px"}
              opacity={0.5}
            >
              {data.key}
            </Text>
            <Text fontSize={"18px"} fontWeight={500} lineHeight={"31.78px"}>
              {data.value}
            </Text>
          </VStack>
        ))}
      </Flex>
    </Box>
  );
};

export default PatientInfo;
